/**
 * original AS3 class  https://source.services.ggs-net.com/Foundation-HTML5/as3Toolbox/blob/master/src/main/flash/com/goodgamestudios/language/constants/CountryFlagConstants.as
 * that class was necessary to have the swf import all the library simbols from the FlagHolder movieclip and was referenced exclusively in CastleFrameOne to force embedding
 * real usage of the symbols occurs in Core.CountrySelectComponent where we access the library symbol concatenating "country_" with the ggsCountryCode.
 *
 * purpose of this empty class is just solve the compile issues.
 */
export class CountryFlagConstants {
}